// eslint-disable-next-line import/no-cycle
import {
  GradeComponentDetails,
  UserActivitiesDetails,
  UserPersistedGrade,
} from '@/services/undergrad/pegasus-pepe-legal/user-grades.service';

export class GradesHelper {
  static calculateTotalGrade(gradesComponents: GradeComponentDetails[]): number {
    const totalGrade = gradesComponents.reduce((grade, gradeComponent) => {
      if (!gradeComponent) return grade;
      return grade + gradeComponent.grade;
    }, 0);

    if (totalGrade >= 10) return 10;
    if (totalGrade === 5.5) return 6;

    const gradeInteger = Math.floor(totalGrade);
    const gradeDecimals = totalGrade - gradeInteger;

    if (gradeDecimals > 0 && gradeDecimals < 0.5) return gradeInteger + 0.5;
    if (gradeDecimals > 0.5) return gradeInteger + 1;

    return totalGrade;
  }

  static normalizeGradeDetails(
    userGrades: UserPersistedGrade,
    disciplineType: string = 'REGULAR',
  ): UserActivitiesDetails {
    const discursiveGrade = userGrades.discursiveExercise;
    const practiceGrade = userGrades.practiceExercise;

    const maxObjectiveExerciseGrade = disciplineType === 'ELETIVA' ? 8 : 2;
    const maxAchievementGrade = disciplineType === 'ELETIVA' ? 2 : 1;

    const mandatoryGrades = {
      achievement: {
        grade: userGrades.achievement,
        maxGrade: maxAchievementGrade,
      },
      objectiveExercise: {
        grade: userGrades.objectiveExercise,
        maxGrade: maxObjectiveExerciseGrade,
      },
      exam: {
        grade:
          userGrades.replacementExam <= userGrades.exam
            ? userGrades.exam
            : userGrades.replacementExam,
        maxGrade: 2,
      },
    };

    if (disciplineType === 'ELETIVA') {
      return {
        grade: userGrades.grade,
        gradeComponents: {
          ...mandatoryGrades,
        },
      };
    }

    let discursiveExercise: any = {
      genericDiscursiveExercise: {
        grade: 0,
        maxGrade: 4,
      },
    };

    if (discursiveGrade > 0 && practiceGrade <= 0) {
      discursiveExercise = {
        discursiveExercise: {
          grade: discursiveGrade,
          maxGrade: 4,
        },
      };
    } else if (practiceGrade > 0 && discursiveGrade <= 0) {
      discursiveExercise = {
        practiceExercise: {
          grade: practiceGrade,
          maxGrade: 4,
        },
      };
    }

    return {
      grade: userGrades.grade,
      gradeComponents: {
        ...mandatoryGrades,
        ...discursiveExercise,
        reviewList: {
          grade: userGrades.reviewList,
          maxGrade: 3,
        },
      },
    };
  }
}
